import React from 'react';
import { AiFillInstagram, AiOutlineTwitter} from 'react-icons/ai';
import BottomMobileMenu from './BottomMobileMenu';
import VisDiv from './frontend_components/VisDiv';
import useMediaQuery from '../hooks/useMediaQuery'
import { useStateContext } from '../context/StateContext';

const Footer = () => {
  const screenSizeDesktop = useMediaQuery("(min-width: 1080px)")
  const {LDB} = useStateContext();
  const currentYear = new Date().getFullYear()
  return (
    <div className="footer-container">

      <p>{`POWERED BY:`}</p>
      <img src="/assets/logo192.png" alt="logo" className='logo-image'/>
      <h2>{`ReLyon`}</h2>
      <p>{`${currentYear} ${LDB("misc", "rights")}`}</p>
    </div>
  )
}

export default Footer